import { app_route_ids, app_route_keys } from "constants/urlPaths";
import { matchPath } from "react-router";
import { BONUS_OFFERINGS_APIS } from "ui/pages/ManageBrandedCommunity/components/AddBonusOfferingModal/constants/AddBonusOfferingModal.api";

const manage_bonus_offerings_resource_apis = {
  [app_route_ids[app_route_keys.manage_branded_community_bonus_offerings]]: ({
    pathname,
  }) => {
    const matchResults = matchPath(pathname, {
      path: app_route_ids[app_route_keys.manage_branded_community_home],
    });
    return {
      api_end_point: BONUS_OFFERINGS_APIS.getOfferingListing,
      queries: {
        community_offering_uuid: matchResults?.params?.branded_community_uuid,
      },
    };
  },
};

export default manage_bonus_offerings_resource_apis;
